import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';
import { ModalDirective } from 'ng2-bootstrap/modal';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { CuestionarioService } from "../_services/cuestionario.service";

import { Nivel } from '../_models/nivel.model';
import { Pregunta } from '../_models/pregunta.model';
import { Cuestionario } from '../_models/cuestionario.model';
import { DragulaService } from 'ng2-dragula';

declare var jQuery:any;

@Component({
  selector: 'cuestionario',
  templateUrl: 'cuestionario.template.html'
})
export class CuestionarioComponent  implements OnInit, OnDestroy {

  @ViewChild('staticModalEvidencias') public staticModalEvidencias:ModalDirective;
  @ViewChild('nombretext') preguntatext;

  subscription: Subscription;

  id_cuestionario: number = 1;
  cuestionario: Cuestionario;
  contador: number;
  listapreguntas: Array<Pregunta> = [];

  listaevidenciassinrelacionar: any = [];
  listaevidenciassinrelacionarcuestionario: any = [];
  listaevidenciasfijas: any = [];
  listaevidencias: any = [];
  listaEvidenciasFiltro: any = [];
  listaCuestionarioEvidenciasFijas: any = [];
  listaCuestionarioTipos: any = [];
  verevidenciasfijas: boolean = false;
  verevidenciascuestionario: boolean = false;

  test: boolean = false;
  mostrarmodal: boolean = false;

  pilaevidencias: any = [];

  editando: boolean = false;

  filterQueryEvidencias:any;

  verEvidenciaInfo: boolean = false;
  id_evidencia_info: number;
  id_cuestionario_tipo: number ;

  
  subs = new Subscription();

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private cuestionarioService: CuestionarioService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute,
              private dragulaService: DragulaService){


              
                                
               


  }


  editar(){
    if (!this.test){
      this.editando = true;
    }
  }

  guardar(){
    if (this.editando){

      this.editando = false;

      let cuestionario: any;

      cuestionario = {
        id_cuestionario : this.cuestionario.id_cuestionario,
        id_cuestionario_tipo: this.cuestionario.id_cuestionario_tipo,
        descripcion: this.cuestionario.descripcion,
        id_modulo: this.cuestionario.id_modulo,
        abr: this.cuestionario.abr
      };

      this.cuestionarioService.setCuestionarioNombre(cuestionario).subscribe(
        data => {
          if (data){

            let al: any = {
              "texto" : "Cuestionario guardado",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);

          }
        }
      );

    }
  }

  cerrarModal(){
    this.staticModalEvidencias.hide();
  }

  abrirModal(){
    this.verevidenciasfijas = false;
    this.verevidenciascuestionario = false;
    this.staticModalEvidencias.show();
  }

  abrirModalFijas(){
    this.verevidenciasfijas = true;
    this.verevidenciascuestionario = false;
    this.mostrarmodal = true;
  }

  abrirModalCuestionario(){
    this.verevidenciasfijas = false;
    this.verevidenciascuestionario = true;
    this.mostrarmodal = true;
  }

  onChangeModal(event){
    this.mostrarmodal = false;
    this.getCuestionarioListaEvidenciasFijas();
    this.getListaEvidenciasFijas();
    this.globalEventsManager.getEvidenciasSinRelacionarCuestionario(this.id_cuestionario);
  }

  ngOnInit(){

    this.seguridad.getLogado();
    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    this.globalEventsManager.menuExtendido(true);

    let _id_cuestionario = this.activatedRoute.snapshot.params["id"];
    if (_id_cuestionario){
      this.id_cuestionario = _id_cuestionario;
    }

    let _test = this.activatedRoute.snapshot.params["test"];
    if (_test){
      this.test = true;
      this.globalEventsManager.menuExtendido(false);
      
    }




    this.subs.add(this.dragulaService.drop('bag1').subscribe((value) => {

         console.log(value); 

            let array_bag1= [];
            let array_bag2= [];
            let contador = 1;
            let nivel = -1;
            let id_respuesta_elemento_arrastrado = 0;
            let id_pregunta_elemento_arrastrado  = 0;
            let id_respueta_elemento_target = 0;
            
            //- Obtenemos el id_respuesta del elemento que hemos arrastrado
         
            jQuery('#'+value.el.id).children().children('.pregunta').each(function () {

              id_respuesta_elemento_arrastrado = jQuery(this).data('id_respuesta');
              id_pregunta_elemento_arrastrado = jQuery(this).data('id_pregunta');
           
            })


            let that = this;
            jQuery('#'+value.target.id).children().each(function () {
             
              //-Si arrastramos una respuesta del nivel 2
              jQuery('#'+value.target.id).children('respuesta').each(function () {
        
                array_bag2.push( {
                  'id_respuesta':jQuery(this).data('id_respuesta')
                } )
                
              });
              
              jQuery(this).children().children('.pregunta').each( function() {

            //   Nos guardamos el id_rspuesta que no sea 0;
                if (jQuery(this).data('id_respuesta') != 0){
                  id_respueta_elemento_target = jQuery(this).data('id_respuesta');
                }
         
                if (jQuery(this).data('id_respuesta') != 0 && nivel == -1){
                    nivel = -1;
                }else{
                  nivel = 0;
                
                }
                array_bag1.push( {
                  'id_solucion':jQuery(this).data('id_solucion'),
                  'id_respuesta':jQuery(this).data('id_respuesta'),
                  'id_pregunta':jQuery(this).data('id_pregunta'),
                  'contador':contador 
                } )
                contador ++;
              });
             
              
            });
      /*      console.log('*****************************************');
            console.log('nivel:'+nivel);
            console.log('arrastrado id_respuesta'+id_respuesta_elemento_arrastrado);
            console.log('arrastrado id_pregunta'+id_pregunta_elemento_arrastrado);
            console.log('destino id_respuesta'+id_respueta_elemento_target);
            console.log('*****************************************');
            */
            if ( nivel == 0 && id_respueta_elemento_target == 0 && id_respuesta_elemento_arrastrado == 0){ //- Estamos en nivel 0 y cambiamos orden de las preguntas principales
    
               console.log('cambiamos orden preguntas iniciales');
               that.setCuestionarioOrdenInicial(array_bag1);       
            }
            if ( nivel == 0 && id_respueta_elemento_target != 0 && id_respuesta_elemento_arrastrado == 0){ //- Estamos en nivel 0 y movemos una pregunta principal a un nivel inferior dentro de una respuesta
    
              console.log('movemos pregunta principal a nivel de respuesta');
              that.CuestionarioMoverPreguntaInicialToSecundaria(id_respueta_elemento_target,id_pregunta_elemento_arrastrado)
             }   
           
            if ( nivel != 0 && id_respueta_elemento_target != 0 && id_respuesta_elemento_arrastrado != 0){ //-Si estamos en un nivel inferior al de las preguntas principales, cambiamos orden de esas preguntas a nivel de respueta
      
              console.log('actualizamos orden preguntas del nivel  de respuesta');
              console.log(array_bag1);
               that.setCuestionarioOrden(array_bag1);
            }    

            if ( nivel != 0 && id_respueta_elemento_target == 0 && id_respuesta_elemento_arrastrado == 0){ //-Si estamos en un nivel inferior al de las preguntas principales, cambiamos orden de esas respuestas a nivel de respueta
      
              console.log('actualizamos orden respuestas del nivel 2  de respuesta');
              that.setCuestionarioRespuestaOrden(array_bag2);
            }  

            if ( nivel == 0  && id_respuesta_elemento_arrastrado != 0){ //-Si estamos en nivel inferior y arrastramos al nivel principal, convertimos esa pregunta en principal
        
              console.log('movemos a pregunta principal');
              console.log(array_bag1);
              that.CuestionarioMoverPreguntaInicial(array_bag1);
          
            }                

        },
        () =>{console.log('complete');}
        )
      );


    let breadcrumb: any = [{
      'path':'#',
      'name':'Cuestionarios'
    }];
    this.globalEventsManager.setNombrePagina(breadcrumb);

    this.getListaPreguntas(this.id_cuestionario);

    this.getCuestionario();

    this.globalEventsManager.evidenciasSinRelacionarEmitter.subscribe((mode)=>{
        if (mode !== null) {
          this.listaevidenciassinrelacionar = mode;
        }
    });

    this.globalEventsManager.evidenciasSinRelacionarCuestionarioEmitter.subscribe((mode)=>{
        if (mode !== null) {
          this.listaevidenciassinrelacionarcuestionario = mode;
        }
    });

    this.globalEventsManager.getEvidenciasSinRelacionar(this.id_cuestionario);
    this.globalEventsManager.getEvidenciasSinRelacionarCuestionario(this.id_cuestionario);

    this.getListaEvidenciasFijas();
    this.getListaEvidencias();
    this.getCuestionarioListaEvidenciasFijas();
    this.getCuestionarioTipos();
    

    this.globalEventsManager.pilaEvidenciasEmitter.subscribe((mode)=>{
        if (mode !== null) {
          this.pilaEvidencias();
        }
    });

    this.cuestionario = new Cuestionario();

  }

  pilaEvidencias(){

    this.pilaevidencias = [];

    let arrayevidencias: any = [];

    jQuery(".checktest").each(function(index) {
      if (jQuery(this).is(':checked')){

        let evidencias: string = jQuery(this).data("evidencias");

        let aux = evidencias.toString().split(",");

        for (let id_evidencia of aux){
          arrayevidencias.push(id_evidencia);
        }


      }

    });

    //inserto las evidencias fijas
    for (let evidencia of this.listaevidenciasfijas){
      this.pilaevidencias.push(evidencia);
    }

    //recorro la lista de evidencias y meto en la pila las que coincidan con el array creado

    for (let evidencia of this.listaevidencias){
      for (let id_evidencia of arrayevidencias){
        if (id_evidencia == evidencia.id_evidencia){

          let encontrado = 0;

          for (let evi of this.pilaevidencias){ //miro si ya existe en la pila y si no la inserto
            //console.log(evi);
            if (evi.id_evidencia == evidencia.id_evidencia){
              encontrado = 1;
            }
          }
          if (encontrado == 0){
            this.pilaevidencias.push(evidencia);
          }

        }
      }
    }


  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
    this.subs.unsubscribe()

  
  }

  getListaEvidenciasFijas() {
  //  this.cuestionarioService.getListaEvidenciasFijas(this.id_cuestionario).subscribe(
      this.cuestionarioService.getCuestionarioListaEvidenciasFijas(this.id_cuestionario).subscribe(
        data => {
          if (data){
            this.listaevidenciasfijas = data.json().evidencias;
            this.pilaEvidencias();
          }
        }
    );
  }

  getListaEvidencias(){
 
    this.cuestionarioService.getListaEvidencias(this.id_cuestionario).subscribe(
        data => {
          if (data){
            this.listaevidencias = data.json().evidencias;
            this.listaEvidenciasFiltro = data.json().evidencias;
      //      console.log(this.listaevidencias);
          }
        }
    );
  }

  getCuestionario(){
    this.cuestionarioService.getCuestionario(this.id_cuestionario).subscribe(
      data => {
        if (data){

          this.cuestionario.id_modulo = data.json().cuestionario.id_modulo;
          this.cuestionario.descripcion = data.json().cuestionario.descripcion;
          this.cuestionario.id_cuestionario = data.json().cuestionario.id_cuestionario;
          this.cuestionario.abr = data.json().cuestionario.abr;
          this.cuestionario.id_cuestionario_tipo = data.json().cuestionario.id_cuestionario_tipo;

          let breadcrumb: any = [
            {
              'path':'/cuestionarios/',
              'name':'Cuestionarios'
            },
            {
              'path':'#',
              'name': this.cuestionario.descripcion
            }];

          this.globalEventsManager.setNombrePagina(breadcrumb);

        }
      }
    );
  }

  onBorrarPregunta(event){

    let pregunta: any;

    pregunta = {
      id_pregunta : event,
      id_respuesta : 0,
      id_cuestionario: this.id_cuestionario
    };



    this.cuestionarioService.deletePregunta(pregunta).subscribe(
      data => {
        if (data){

          let encontrado : number;

          for (let i = 0; i < this.listapreguntas.length; i++){
            if (this.listapreguntas[i].id_pregunta == event){
              encontrado = i;
            }
          }

          this.listapreguntas.splice(encontrado,1);

        }
      }
    );

  }

  anadirPregunta(){

    let encontrado: boolean = false;

    for (let pregunta of this.listapreguntas){

      if (pregunta.id_pregunta == 0){
        encontrado = true;
      }

    }

    if (!encontrado){

      let nuevapregunta = new Pregunta();
      nuevapregunta.nivel = 1;
      nuevapregunta.pregunta = "pregunta nueva";
      nuevapregunta.editar = true;
      nuevapregunta.seleccionar = true;

      this.listapreguntas.push(nuevapregunta);


    }

  }

  getListaPreguntas(id_cuestionario: number){

    let lista: any;

    if (!this.test){

      this.cuestionarioService.getListaPreguntas(id_cuestionario).subscribe(
        data => {
          if (data){
            lista = data.json().cuestionario;

            for (let pregunta of lista){

              let nuevapregunta = new Pregunta();

              nuevapregunta.nivel = pregunta.nivel;
              nuevapregunta.pregunta = pregunta.pregunta;
              nuevapregunta.respuestas = pregunta.respuestas;
              nuevapregunta.id_pregunta = pregunta.id_pregunta;
              nuevapregunta.urldocumento = pregunta.urldocumento;

              this.listapreguntas.push(nuevapregunta);
              console.log(this.listapreguntas);

            }
          }
        }
      );

    }else{
      this.cuestionarioService.getFullCuestionario(id_cuestionario).subscribe(
        data => {
          if (data){
            lista = data.json().cuestionario;

            console.log(lista);

            for (let pregunta of lista){

              let nuevapregunta = new Pregunta();

              nuevapregunta.nivel = pregunta.nivel;
              nuevapregunta.pregunta = pregunta.pregunta;
              nuevapregunta.respuestas = pregunta.respuestas;
              nuevapregunta.id_pregunta = pregunta.id_pregunta;
              nuevapregunta.urldocumento = pregunta.urldocumento;

              this.listapreguntas.push(nuevapregunta);

            }
          }
        }
      );
    }
  }


  getCuestionarioListaEvidenciasFijas(){

    this.cuestionarioService.getCuestionarioListaEvidenciasFijas(this.id_cuestionario).subscribe(
      data => {
        
        this.listaCuestionarioEvidenciasFijas = data.json().evidencias;
    //    console.log( this.listaCuestionarioEvidenciasFijas);
        
      }
    )}
  
    mostrarEvidenciaInfo(id_evidencia:number){
      this.id_evidencia_info = id_evidencia;
      this.verEvidenciaInfo = true;
    
    }

    cerrarInfoModal(){
      this.verEvidenciaInfo = false;
      this.getListaEvidencias();
    }    


  getCuestionarioTipos(){

    this.cuestionarioService.getCuestionarioTipos().subscribe(
      data => {
        
        this.listaCuestionarioTipos= data.json().cuestionario;
    //    console.log(this.listaCuestionarioTipos);
      }
    )}


    setCuestionarioOrden(datos:any){

      this.cuestionarioService.setCuestionarioOrden(this.id_cuestionario,datos).subscribe(
          data => {
            if (data){
              
            }
      })
    }

    setCuestionarioRespuestaOrden(datos:any){

      this.cuestionarioService.setCuestionarioRespuestaOrden(this.id_cuestionario,datos).subscribe(
          data => {
            if (data){
              console.log('respuesta del servicio cuestionario respuesta orden');
            }
      })
    }


    setCuestionarioOrdenInicial(datos:any){

      this.cuestionarioService.setCuestionarioOrdenInicial(this.id_cuestionario,datos).subscribe(
          data => {
            if (data){
             
            }
      })
    }

    CuestionarioMoverPreguntaInicial(datos:any){
      
      this.cuestionarioService.CuestionarioMoverPreguntaInicial(this.id_cuestionario,datos).subscribe(
          data => {
            if (data){
              console.log('respuesta del servicio mover pregunta inicial');
            }
      })
      
    }

    CuestionarioMoverPreguntaInicialToSecundaria(id_respuesta:any,id_pregunta:any){
      
      this.cuestionarioService.CuestionarioMoverPreguntaInicialToSecundaria(this.id_cuestionario,id_respuesta,id_pregunta).subscribe(
          data => {
            if (data){
              console.log('respuesta del servicio mover pregunta inicial');
            }
      })
      
    }


//---------------------------------------------------------------------
//-                            FILTROS
//---------------------------------------------------------------------
   
limpiarFiltros(){

  this.getListaEvidencias();
  this.globalEventsManager.getEvidenciasSinRelacionar(this.id_cuestionario);


}

changeValueEvidenciaFiltros(filtro){

 this.listaevidencias = filtro;
 if (filtro.tipo == 'limpiar' ){
   this.limpiarFiltros();      
 }else{
   this.listaevidenciassinrelacionar = filtro.value;
 }

 }


}



// WEBPACK FOOTER //
// ./src/app/cuestionario/cuestionario.component.ts